// extracted by mini-css-extract-plugin
export var content = "_d9-3";
export var list = "_d9-4";
export var settingsContent = "_d9-7";
export var settingsPanel = "_d9-8";
export var state = "_d9-6";
export var triggerBadge = "_d9-2";
export var triggerButton = "_d9-1";
export var triggerShell = "_d9-0";
export var unreadDot = "_d9-5";